// extracted by mini-css-extract-plugin
module.exports = {"item":"K_cx","item__image":"K_cy","item__title":"K_cS","item__counter":"K_cT","item__active":"K_cV"};